import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { NgxSpinnerService } from 'ngx-spinner';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { Document } from 'src/app/shared/models/documents/document';
import { environment } from 'src/environments/environment';
import { ErrorService } from '../error/error.service';
import { ApiBaseService } from './api-base.service';

@Injectable({
  providedIn: 'root'
})
export class DocumentsApiService extends ApiBaseService {

  baseUrl = environment.backend_host + '/api/documents';

  constructor(
    public http: HttpClient,
    protected errorService: ErrorService,
    protected spinner: NgxSpinnerService) {
    super(spinner, errorService);
  }

  public uploadDocument = (formData: FormData): Observable<Document> =>
    this.http.post(`${this.baseUrl}/`, formData)
      .pipe(map(this.deserializeAs(Document)));

  public deleteDocument = (id: number): Observable<any> =>
      this.http.delete(`${this.baseUrl}/${id}`);
}